/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from "react";
import MainTitle from "components/MainTitle";
import FormContainer from "components/FormContainer";
import Fieldset from "components/Fieldset";
import Legend from "components/Legend";
import InputControl from "components/InputControl";
import FormActions from "components/FormActions";
import Button from "components/Button";
import Input from "components/Input";
import ChangePasswordApi from "core/api/changePassword/changePasswordApi";
import Modal from "components/Modal";
import { store } from "store.js";
import { Text } from "mondrian-react";

import PasswordTips from "components/PasswordTips";
import {
  containsMinLength,
  containsNumbers,
  containsLowercase,
  containsRepeatedNumbers,
  containsForbidenCharacters,
  containsSequenceOfNumbers,
} from "core/Utils";
import Analytics from "core/Utils/Analytics";

const ChangePasswordPage = ({
  setForm,
  formData,
  navigation,
  setIsLoading,
}) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { dispatch } = globalState;
  useEffect(function () {
    Analytics().setVirtualPageView();
    dispatch({
      type: "SET_GA",
      payload: { currentFlow: "alterar-senha" },
    });
  }, []);

  const { accesstoken = "undefined" } = state;

  const { next } = navigation;
  const logoutLink = process.env.REACT_APP_PING_AUTHORIZE;
  const [newPassword, setNewPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [newPassValid, setNewPassValid] = useState(false);
  const [confirmPassValid, setConfirmPassValid] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  function validateNewPassword(value) {
    setNewPassValid(false);
    setNewPassword(value);
  
    if (!containsMinLength(value)) {
      setNewPasswordError("A senha deve conter pelo menos 8 caracteres");
    } else if (!containsLowercase(value)) {
      setNewPasswordError("A senha deve conter pelo menos 1 letra minúscula");
    } else if (containsForbidenCharacters(value)) {
      setNewPasswordError(
        "Simbolo inválido, Símbolos permitidos: @ # $ % & * _ - + = < >"
      );
    } else if (containsRepeatedNumbers(value)) {
      setNewPasswordError(
        "3 caracteres repetidos em sequência não são permitidos. Ex:(111, 222, aaa)"
      );
    } else if (containsSequenceOfNumbers(value)) {
      setNewPasswordError(
        "3 números em sequência não são permitidos. Ex:(123)"
      );
    } else if (!containsNumbers(value)) {
      setNewPasswordError("A senha deve conter pelo menos 1 número");
    } else if (password.length <= 5) {
    } else if (password === value) {
      setNewPasswordError("A nova senha está igual a senha atual");
    } else {
      setNewPasswordError("");
      setNewPassValid(true);
    }
  }

  useEffect(
    function () {
      if(confirmNewPassword){
        validateConfirmPassword(confirmNewPassword)
      }
    },
    [newPassword,confirmNewPassword]
  );
  
  function validateConfirmPassword(value) {
    setConfirmNewPassword(value);
    if (value !== newPassword) {
      setConfirmPasswordError("A senha não está igual ao campo anterior");
      setConfirmPassValid(false);
    } else {
      setConfirmPasswordError("");
      setConfirmPassValid(true);
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    let result = await ChangePasswordApi(
      {
        password: password,
        newPassword: newPassword,
      },
      accesstoken
    );
    setIsLoading(false);

    let { error = null } = result;
    if (error != null) {
      setModalContent(error);

      if (result.code === 422) {
        Analytics().setEvent({
          eventAction: "callback:alterar-senha",
          eventLabel: "tentativa:erro_senha_invalida",
        });
        return;
      }
      if (result.code === 401) {
        setTimeout(function () {
          window.location.href = logoutLink;
        }, 2000);
      }
    } else {
      Analytics().setEvent({
        eventAction: "callback:alterar-senha",
        eventLabel: "tentativa:sucesso",
      });
      next();
    }

    const { message } = error.warning;
    Analytics().setErrorEvent({
      eventAction: "callback:alterar-senha",
      eventLabel: message,
      code: error?.errorCode
      
    });

  }

  function onRequestClose(data = {}) {
    setModalContent(null);
  }

  return (
    <>
      {modalContent && (
        <Modal onClose={onRequestClose} content={modalContent} />
      )}
      <FormContainer onSubmit={handleSubmit}>
        <MainTitle sm tabIndex="20">
          Alterar senha
        </MainTitle>
        <Legend>
          <Text>
            Preencha os campos abaixo para alterar sua senha de acesso.
            Lembrando que a sua nova senha deve ter ao menos 8 caracteres,
            letras e números.
          </Text>
        </Legend>
        <Fieldset>
          <InputControl>
            <Input
              tabIndex="20"
              type="password"
              name="password"
              id="password"
              label="Senha atual"
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputControl>
          <InputControl>
            <Input
              tabIndex="21"
              type="password"
              name="newPassword"
              id="newPassword"
              label="Nova senha"
              error={newPasswordError}
              onChange={(e) => validateNewPassword(e.target.value)}
              disabled={password.length <= 5}
            />
          </InputControl>
          <InputControl>
            <PasswordTips tabIndex="22" password={newPassword} />
          </InputControl>
          <InputControl>
            <Input
              tabIndex="23"
              type="password"
              name="confirmNewPassword"
              id="confirmNewPassword"
              label="Confirmar nova senha"
              error={confirmPasswordError}
              onChange={(e) => validateConfirmPassword(e.target.value)}
              disabled={
                !newPassword.length > 0 || !newPassValid || password.length <= 5
              }
            />
          </InputControl>
          <FormActions>
            <Button
              disabled={!(newPassValid && confirmPassValid)}
              tabIndex="24"
            >
              Salvar
            </Button>
          </FormActions>
        </Fieldset>
      </FormContainer>
    </>
  );
};

export default ChangePasswordPage;
